/**
 * Dependencies.
 */
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

import ConfigurationResultModel from './configuration-result.model';
import ConfigurationModel from './configuration.model';

/**
 * Service `ConfigurationService`.
 */
class ConfigurationService extends BaseService<ConfigurationModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      ConfigurationModel,
      ConfigurationModel.name,
      applicationConstant.apiCustomerPrivateUrl
    );
  }

  /**
   * Get distribution center radius.
   */
  getDistributionCenterRadius(): Promise<ConfigurationResultModel> {
    const endpoint = `${this.getModelEndpoint}/distanceForAutomaticApprovalOfCustomerRequest`;

    return this.GET(endpoint);
  }

  /**
   * Get minimum product expiration.
   */
  getMinimumProductExpiration(): Promise<ConfigurationResultModel> {
    const endpoint = `${this.getModelEndpoint}/minimumDaysForItemExpirationDateValidation`;

    return this.GET(endpoint);
  }

  /**
   * Get request maximum.
   */
  getRequestMaximum(): Promise<ConfigurationResultModel> {
    const endpoint = `${this.getModelEndpoint}/deliveryRequestMaximum`;

    return this.GET(endpoint);
  }
}

/**
 * Export `configurationService`.
 */
export const configurationService = new ConfigurationService();
